import { Button } from '@jobber-project/jobber-ui'
import { ReactNode } from 'react'
import styled from 'styled-components'

const StyledButton = styled(Button)`
  height: 56px;
  margin-bottom: 20px;

  & span {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  & svg {
    margin-right: 10px;
  }
`

type AuthSocialSignInButtonProps = {
  loading?: boolean
  icon: ReactNode
  title: string
  onClick: React.MouseEventHandler<HTMLButtonElement>
}

function AuthSocialSignInButton({
  loading = false,
  icon,
  title,
  onClick,
}: AuthSocialSignInButtonProps) {
  return (
    <StyledButton
      outlined
      fluid
      loading={loading}
      size="large"
      onClick={onClick}
    >
      {icon}
      {title}
    </StyledButton>
  )
}

export default AuthSocialSignInButton
